import { Expose } from "@nts/std/serialization";
import { ServiceRequest } from './service-request';
import { IdentityInterface, RemoveRequestInterface } from '@nts/std/interfaces';

export class RemoveRequest<TIDentity extends IdentityInterface> extends ServiceRequest implements RemoveRequestInterface<TIDentity> {

    @Expose()
    identity: TIDentity;

}
